import type { ValueOf } from '../util/typeUtils';

export const TEMPLATE_COMMANDS = {
    create: 'create',
    createDivisionFooter: 'createDivisionFooter',
    createDivisionHeader: 'createDivisionHeader',
    createDivisionMail: 'createDivisionMail',
    createFooters: 'createFooters',
    createHeaders: 'createHeaders',
    createSystemMail: 'createSystemMail',
    delete: 'delete',
    update: 'update',
    updateDivisionFooter: 'updateDivisionFooter',
    updateDivisionHeader: 'updateDivisionHeader',
    updateDivisionMail: 'updateDivisionMail',
    updateFooters: 'updateFooters',
    updateHeaders: 'updateHeaders',
    updateSystemMail: 'updateSystemMail',
} as const;

export type TEMPLATE_COMMAND = ValueOf<typeof TEMPLATE_COMMANDS>;
